export const isEmptyArray = (array?: any[] | undefined): boolean =>
  !array || array.length === 0;

export const isArrayWithItems = (array?: any[] | undefined) =>
  !isEmptyArray(array);
